module.exports = __webpack_public_path__ + "static/media/car1.3b9bc963.jpg";